import { useState } from 'react'
import styled from 'styled-components'
import { Loading, Button } from 'carbon-components-react'
import TileHeader from '../../components/TileHeader/TileHeader'
import ConfirmModal from '../../components/Modal/ConfirmModal'
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper'
// hooks
import useAttachmentsGrid from './useAttachmentsGrid'
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';
import { toaster } from '../../helpers/toaster';

const Attachments = () => {
  const {
    addAttachmentsButton,
    attachmentGrid,
    attachmentsSearch,
    attachmentsLoading,
  } = useAttachmentsGrid()

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Attachments report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('attachments')
      .then(({ task_id }) => {
        toaster('Generating attachments report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };

  return (
    <Container>
      <ContentContainer>
        <TileHeader
          title="Attachments"
          subtitle=""
          size="lg"
        />
        {
          attachmentsLoading ?
            <Loading
            />
            :
            <></>
        }
        <PageContent>
          <ActionBar>
            {attachmentsSearch()}
            <ButtonPadding>
              <Button
                kind="secondary"
                onClick={() => setOpenReportModal(true)}
                disabled={reportStatus === 'polling'}
                style={btnStyle}
              >{reportStatus === 'polling' ? 'Generating...' : 'Generate Report'}</Button>
              {addAttachmentsButton()}
            </ButtonPadding>
          </ActionBar>
          {attachmentGrid()}
        </PageContent>
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />
      </ContentContainer>
    </Container>
  )
}

export default Attachments

const PageContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 24px;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
`
const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ButtonPadding = styled.div`
  display: flex;
  gap: 8px;
`

const btnStyle = {
  padding: "11px 18px",
  height: "auto",
  minHeight: "unset",
  borderRadius: "10px",
  fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
  fontWeight: 700,
  fontSize: "13.5px",
};
